import { Box, Icon, Text, colors, dimensions, zIndex } from '@factorialco/deprecated-design-system'

import { NpsWidgetVariant } from 'modules/nps/lib/types'

import { ColorConfig, Props } from './types'

const getColorConfig = (variant: NpsWidgetVariant): ColorConfig => {
  const gradientColor = (baseColor: string) => {
    const transparentColor = baseColor.replace(/[\d\.]+\)$/g, '0)')

    return `radial-gradient(132% 118% at -28% -54%, ${baseColor} 0%, ${transparentColor} 100%)`
  }
  const defaultConfig: ColorConfig = {
    containerBackground: gradientColor(colors.radicalRed1000),
    iconColor: 'radicalRed1000',
  }

  switch (variant) {
    case 'radical':
      return defaultConfig
    case 'champagne':
      return {
        containerBackground: gradientColor(colors.champagne1200),
        iconColor: 'champagne1200',
      }
    case 'viridian':
      return {
        containerBackground: gradientColor(colors.viridian1000),
        iconColor: 'viridian1000',
      }
    case 'tangerine':
      return {
        containerBackground: gradientColor(colors.tangerine1000),
        iconColor: 'tangerine1000',
      }
    default:
      return defaultConfig
  }
}

const _Wrapper = ({
  title,
  children,
  icon,
  iconColor,
  gradientBackground,
  variant,
  onClose,
}: Props) => {
  const { iconColor: auxIconColor, containerBackground } = getColorConfig(variant)

  return (
    <Box
      boxShadow="s200"
      padding="s32"
      borderRadius={{ all: 'abs016' }}
      overflowY="hidden"
      gap="s32"
      position="absolute"
      style={{
        width: '696px',
        zIndex: zIndex.popovers,
        bottom: dimensions.s32,
        left: dimensions.s32,
      }}
      background="white"
    >
      <Box
        position="absolute"
        width="full"
        height="full"
        style={{
          top: '0',
          left: '0',
          background: !!gradientBackground ? gradientBackground : containerBackground,
          zIndex: '-1',
        }}
      />
      <Box flexDirection="row" gap="s24" alignItems="center">
        <Box padding="s16" borderRadius={{ all: 'rel333' }} background="grey000White">
          <Icon.Large icon={icon} color={!!iconColor ? iconColor : auxIconColor} />
        </Box>
        <Text weight="semibold" size="400" color="grey1000">
          {title}
        </Text>
      </Box>
      {children}
      <Box
        style={{
          position: 'absolute',
          top: dimensions.s16,
          right: dimensions.s16,
          cursor: 'pointer',
        }}
        onClick={onClose}
      >
        <Icon.Medium icon="cross" />
      </Box>
    </Box>
  )
}

export default _Wrapper
